export const lineOpen = ref(true);

export const infoOpen = ref(true);
